document.addEventListener("DOMContentLoaded", function () {

  const isLoggedIn = document.body.classList.contains("customer-logged-in");
  const isExpoPage = window.location.pathname === "/pages/expo-brands";
  const isCollection = document.body.classList.contains("template-collection");
  const isProduct = document.body.classList.contains("template-product");

  /* -------------------------
     LOGIN SUCCESS
  --------------------------*/

  if (isLoggedIn && localStorage.getItem("expo_login_flow") === "true") {
    localStorage.setItem("expo_login_success", "true");
  }

  /* -------------------------
     BRAND CLICK
  --------------------------*/

  if (isExpoPage) {

    document.querySelectorAll(".expo-brand-card").forEach(function (card) {

      card.addEventListener("click", function (e) {

        // Customer already logged in
        if (isLoggedIn) {
          return;
        }

        e.preventDefault();

        const collectionUrl = this.dataset.collection;

        localStorage.setItem("expo_login_flow", "true");
        localStorage.setItem("expo_selected_collection", collectionUrl);

        window.location.href =
          "/account/login?return_url=/pages/expo-brands";

      });

    });

  }

  /* -------------------------
     BOTTOM BAR
  --------------------------*/

  const bottomBar = document.getElementById("expoBottomBar");

  if (
    bottomBar &&
    isLoggedIn &&
    localStorage.getItem("expo_login_flow") === "true" &&
    (isCollection || isProduct)
  ) {
    bottomBar.style.display = "flex";
  }

});